<template>
    <div>
        <div class="dialog-back" :class="{'show': value}"></div>
        <div class="dialog-wrap" :class="{'show': value}">
            <div class="dialog-win" :class="{'show': value}">
                <div class="header">
                    {{title}}
                    <div class="dialog-close close-ico" @click="close"></div>
                </div>
                <div class="content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['value', 'title', 'scroll'],
        data(){
            return {

            }
        },
        methods:{
            close(){
                this.$emit('input', false)
                this.$emit('close')
            }
        },
        watch:{
            value(newVal, oldVa){
                if (this.scroll) return;
                if(newVal){
                    document.documentElement.style.overflow = 'hidden';
                    document.documentElement.style.height = '100vh';
                    document.documentElement.style.width = '100vw';
                } else {
                    document.documentElement.style.overflow = 'auto';
                    document.documentElement.style.height = 'auto';
                    document.documentElement.style.width = 'auto';
                }
            }
        }
    }
</script>
